import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";

class Photo extends Component {
	state = {
		data: ""
    };
    
    constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount() {
		this.state = {
		};
	}

	handleConfirm = () => {
		this.props.handlePhotoDelete({ id: this.props.id }, this.props.token);
		this.handleCancel();
	};

	handleCancel = () => {
		this.setState({
			modal: false
		});
	};

	openModal = () => {
		console.log("OPENM MODAL");
		this.setState({
			modal: true
		});
	};
	render() {
		return (
			<React.Fragment>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.modal}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea Borrar?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancel}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Card>
						<CardMedia
							image={this.props.thumbnailurl}
							title="Imagen"
							style={{ width: "100px", height: "100px", margin: "auto" , marginTop: "10px"}}></CardMedia>
                         <CardActions disableSpacing>
                        <IconButton aria-label="Borrar" onClick={this.openModal}>
                        <DeleteIcon />
                        </IconButton>
                        </CardActions>
                </Card>
				</React.Fragment>
		);
	}
}
export default Photo;
